<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Transferencias BAM
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[5047,5017]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(0)"
				[(ngModel)]="history" [value]="0" checked id="tab1">
			<label class="" for="tab1" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-arrow-right-arrow-left"></i>Realizar Transferencia
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(1)" 
				[(ngModel)]="history" [value]="1" id="tab2" class="tab-content-2">
			<label for="tab2" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-users"></i>Pago de Planilla
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(2)" 
				[(ngModel)]="history" [value]="2" id="tab3" class="tab-content-3">
			<label for="tab3" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-percent"></i>Pago de Impuestos
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(3)" 
				[(ngModel)]="history" [value]="3" id="tab4" class="tab-content-4">
			<label for="tab4" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-credit-card"></i>Pago tarjeta de Credito
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(4)" 
				[(ngModel)]="history" [value]="4" id="tab5" class="tab-content-5">
			<label for="tab5" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-solid fa-money-bill-wheat"></i>Pago de Prestamo
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(5)" 
				[(ngModel)]="history" [value]="5" id="tab6" class="tab-content-6">
			<label for="tab6" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-earth-americas"></i>Transferencia Internacional
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(6)" 
				[(ngModel)]="history" [value]="6" id="tab7" class="tab-content-7">
			<label for="tab7" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-user-friends"></i>Agregar Favoritos
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(7)" 
				[(ngModel)]="history" [value]="7" id="tab8" class="tab-content-8">
			<label for="tab8" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-book-bookmark"></i>Historial de Transferencias
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(8)" 
				[(ngModel)]="history" [value]="8" id="tab9" class="tab-content-9">
			<label for="tab9" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-book-open"></i>Historial de Favoritos
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(9)" 
				[(ngModel)]="history" [value]="9" id="tab10" class="tab-content-10">
			<label for="tab10" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-book"></i>Consultas
			</label>

		</div>
		<div class="row" [hidden]="history!=0">
			<div class="col" id="list-container">
				<app-bam-transfer-transaction *ngIf="history==0"></app-bam-transfer-transaction>
			</div>
		</div>
		<div class="row" [hidden]="history!=1">
			<div class="col" id="list-container">
				<app-bam-payroll *ngIf="history==1"></app-bam-payroll>
			</div>
		</div>
		<div class="row" [hidden]="history!=2">
			<div class="col" id="list-container">
				<app-bam-taxes *ngIf="history==2"></app-bam-taxes>
			</div>
		</div>
		<div class="row" [hidden]="history!=3">
			<div class="col" id="list-container">
				<app-bam-credit-card *ngIf="history==3"></app-bam-credit-card>
			</div>
		</div>
		<div class="row" [hidden]="history!=4">
			<div class="col" id="list-container">
				<app-bam-loan *ngIf="history==4"></app-bam-loan>
			</div>
		</div>
		<div class="row" [hidden]="history!=5">
			<div class="col" id="list-container">
				<app-bam-international-transfer *ngIf="history==5"></app-bam-international-transfer>
			</div>
		</div>
		<div class="row" [hidden]="history!=6">
			<div class="col" id="list-container">
				<app-bam-add-favorite *ngIf="history==6"></app-bam-add-favorite>
			</div>
		</div>
		<div class="row" [hidden]="history!=7">
			<div class="col" id="list-container">
				<app-bam-transfer-history *ngIf="history==7"></app-bam-transfer-history>
			</div>
		</div>
		<div class="row" [hidden]="history!=8">
			<div class="col" id="list-container">
				<app-bam-favorites-history *ngIf="history==8"></app-bam-favorites-history>
			</div>
		</div>
		<div class="row" [hidden]="history!=9">
			<div class="col" id="list-container">
				<app-bam-queries *ngIf="history==9"></app-bam-queries>
			</div>
		</div>
	</div>

</div>